module.exports = __webpack_public_path__ + "media/img/pay-5-44285937f2c4870f885885272ca32375.svg";